import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
import ExpressionTree from './ExpressionTree';
import CombinedName from './CombinedName';
import ExpressionNode from './ExpressionNode';

function getUniqueId() {
  return 'xxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line no-bitwise
    var r = Math.random() * 16 | 0; // eslint-disable-next-line no-bitwise

    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

var CombinedMetric = /*#__PURE__*/function () {
  function CombinedMetric(combinedMetric) {
    if (!combinedMetric) {
      combinedMetric = {
        name: {
          auto: true,
          prefix: null
        },
        displayOnly: true,
        filter: {
          children: [],
          'function': 'highestAverage',
          id: getUniqueId(),
          parameters: [{
            name: 'Top N',
            value: 10
          }],
          type: 'function'
        },
        expressionTree: {
          root: {
            searchObject: {
              expression: []
            },
            children: [],
            type: 'metric',
            id: getUniqueId(),
            uiIndex: 0
          }
        },
        scalarTransforms: [{
          'function': 'current',
          children: [],
          id: getUniqueId(),
          parameters: [],
          type: 'function'
        }],
        context: ''
      };
    }

    if (combinedMetric.title) {
      this._title = combinedMetric.title;
    }

    if (combinedMetric.id) {
      this._id = combinedMetric.id;
    }

    if (combinedMetric.name) {
      this._name = new CombinedName(combinedMetric.name);
    }

    if (combinedMetric.displayOnly) {
      this._displayOnly = combinedMetric.displayOnly;
    }

    if (combinedMetric.mType) {
      this._mType = combinedMetric.mType;
    }

    if (combinedMetric.namingSchema) {
      this._namingSchema = combinedMetric.namingSchema;
    }

    if (combinedMetric.expressionTree) {
      this._expressionTree = new ExpressionTree(combinedMetric.expressionTree);
    }

    if (combinedMetric.alias) {
      this._alias = new ExpressionNode(combinedMetric.alias);
    }

    if (combinedMetric.filter) {
      this._filter = new ExpressionNode(combinedMetric.filter);
    }

    if (combinedMetric.scalarTransforms) {
      this._scalarTransforms = combinedMetric.scalarTransforms ? combinedMetric.scalarTransforms.map(function (st) {
        return new ExpressionNode(st);
      }) : null;
    }

    if (combinedMetric.calculationDelay) {
      this._calculationDelay = combinedMetric.calculationDelay;
    }

    if (combinedMetric.originId) {
      this._originId = combinedMetric.originId;
    }

    if (combinedMetric.owner) {
      this._owner = combinedMetric.owner;
    }

    if (combinedMetric.context) {
      this._context = combinedMetric.context;
    }

    if (combinedMetric.excludeComposites) {
      this._excludeComposites = combinedMetric.excludeComposites;
    }

    if (combinedMetric.includeCubes) {
      this._includeCubes = combinedMetric.includeCubes;
    }

    if (combinedMetric.isWhatermarkBased) {
      this._isWatermarkBased = combinedMetric.isWhatermarkBased;
    }

    if (combinedMetric.startBucketMode) {
      this._startBucketMode = combinedMetric.startBucketMode;
    }
  }

  var _proto = CombinedMetric.prototype;

  _proto.getCombinedMetricObjectification = function getCombinedMetricObjectification() {
    var ret = {};

    if (this._title) {
      ret.title = this._title;
    }

    if (this._id) {
      ret.id = this._id;
    }

    if (this._name) {
      ret.name = this._name.getCombinedNameObjectification();
    }

    if (this._displayOnly) {
      ret.displayOnly = this._displayOnly;
    }

    if (this._mType) {
      ret.mType = this._mType;
    }

    if (this._namingSchema) {
      ret.namingSchema = this._namingSchema;
    }

    if (this._expressionTree) {
      ret.expressionTree = this._expressionTree.getExpressionTreeObjectification();
    }

    if (this._alias) {
      ret.alias = this._alias.getExpressionNodeObjectification();
    }

    if (this._filter) {
      ret.filter = this._filter.getExpressionNodeObjectification();
    }

    if (this._scalarTransforms) {
      ret.scalarTransforms = this._scalarTransforms.map(function (st) {
        if (st) {
          return st.getExpressionNodeObjectification();
        }

        return null;
      });
    }

    if (this._calculationDelay) {
      ret.calculationDelay = this._calculationDelay;
    }

    if (this._originId) {
      ret.originId = this._originId;
    }

    if (this._owner) {
      ret.owner = this._owner;
    }

    if (this._context) {
      ret.context = this._context;
    }

    if (this._excludeComposites) {
      ret.excludeComposites = this._excludeComposites;
    }

    if (this._includeCubes) {
      ret.includeCubes = this._includeCubes;
    }

    if (this._isWatermarkBased) {
      ret.isWatermarkBased = this._isWatermarkBased;
    }

    if (this._startBucketMode) {
      ret.startBucketMode = this._startBucketMode;
    }

    return ret;
  };

  _createClass(CombinedMetric, [{
    key: 'title',
    get: function get() {
      return this._title;
    }
  }, {
    key: 'id',
    get: function get() {
      return this._id;
    }
  }, {
    key: 'name',
    get: function get() {
      return this._name;
    }
  }, {
    key: 'displayOnly',
    get: function get() {
      return this._displayOnly;
    }
  }, {
    key: 'mTYpe',
    get: function get() {
      return this._mType;
    }
  }, {
    key: 'namingSchema',
    get: function get() {
      return this._namingSchema;
    }
  }, {
    key: 'expressionTree',
    get: function get() {
      return this._expressionTree;
    }
  }, {
    key: 'alias',
    get: function get() {
      return this._alias;
    }
  }, {
    key: 'filter',
    get: function get() {
      return this._filter;
    }
  }, {
    key: 'scalarTransforms',
    get: function get() {
      return this._scalarTransforms;
    }
  }, {
    key: 'calculationDelay',
    get: function get() {
      return this._calculationDelay;
    }
  }, {
    key: 'originId',
    get: function get() {
      return this._originId;
    }
  }, {
    key: 'owner',
    get: function get() {
      return this._owner;
    }
  }, {
    key: 'context',
    get: function get() {
      return this._context;
    }
  }, {
    key: 'excludeComposites',
    get: function get() {
      return this._excludeComposites;
    }
  }, {
    key: 'includeCubes',
    get: function get() {
      return this._includeCubes;
    }
  }, {
    key: 'isWatermarkBased',
    get: function get() {
      return this._isWatermarkBased;
    }
  }, {
    key: 'startBucketMode',
    get: function get() {
      return this._startBucketMode;
    }
  }]);

  return CombinedMetric;
}();

export { CombinedMetric as default };